import FavoriteDentist from './FavoriteDentist';

export default FavoriteDentist;
